import { useApiTradeV1TradeCompaniesRetrieve } from 'api';
import { Link, useParams } from 'react-router-dom';
import { Button, Page, Section } from 'ui';

import { CompanySites } from '../../components/CompanySites/CompanySites';

export const CompanySiteMaterials = () => {
  const { companyId } = useParams();
  const { data: tradeCompany } = useApiTradeV1TradeCompaniesRetrieve(Number(companyId));

  return (
    <Page>
      <Page.BackButton
        component="a"
        href={`/ground-control/manage_company/${tradeCompany?.company_id}/`}
        disabled={!tradeCompany}
      >
        Manage {tradeCompany?.name}
      </Page.BackButton>

      <Page.Title title="Manage site materials" />
      <Page.Divider />

      <Section
        title="Site materials"
        action={
          tradeCompany ? (
            <Button component={Link} to={`/ground-control/v2/manage-company/${tradeCompany.id}/site-materials/new`}>
              Add site material
            </Button>
          ) : null
        }
      >
        <CompanySites tradeCompanyId={Number(companyId)} />
      </Section>
    </Page>
  );
};
